<template>
  <v-card flat>
    <v-card-title class="headline">Login</v-card-title>
    <v-card-text>
      <router-link to="room">Room Picker</router-link>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      msg: 'login'
    }
  },
  mounted(){
      this.loadRooms();
  },
  methods: {
      loadRooms(){
          this.rooms = [
              {name: "foo"}
          ]
      }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Login.vue